// extracted by mini-css-extract-plugin
export default {"faults":"FaultRulesDashboard_faults__BpTo0"};